import axios from 'axios'

// API基础URL
const BASE_URL = process.env.VUE_APP_BASE_API || 'http://localhost:8080'

/**
 * 记录页面访问
 */
export function recordPageVisit(pagePath, pageTitle) {
  try {
    // 异步发送，不阻塞页面加载
    axios.post(`${BASE_URL}/api/stats/page-visit`, {
      pagePath,
      pageTitle
    }).catch(err => {
      console.warn('记录页面访问失败:', err)
    })
  } catch (error) {
    console.warn('记录页面访问异常:', error)
  }
}

/**
 * 记录内容阅读
 */
export function recordContentRead(contentId, contentType, title) {
  try {
    axios.post(`${BASE_URL}/api/stats/content-read`, {
      contentId,
      contentType,
      title
    }).catch(err => {
      console.warn('记录内容阅读失败:', err)
    })
  } catch (error) {
    console.warn('记录内容阅读异常:', error)
  }
}

/**
 * 获取统计数据概览
 */
export function getStatsOverview() {
  return axios.get(`${BASE_URL}/api/stats/overview`)
}

/**
 * 获取热门页面
 */
export function getTopPages(limit = 10) {
  return axios.get(`${BASE_URL}/api/stats/top-pages`, {
    params: { limit }
  })
}

/**
 * 获取热门内容
 */
export function getTopContents(contentType, limit = 10) {
  return axios.get(`${BASE_URL}/api/stats/top-contents`, {
    params: { contentType, limit }
  })
}
